import React from 'react';

/**
 * PlusIcon - holito brand-tier icon (2px stroke, 24 grid, the notch where applicable).
 * Geometry from the brand guide (docs/DESIGN.md section 08 / Iconography).
 */
export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 5 V19" />
    <path d="M5 12 H19" />
  </svg>
);
